import { render, staticRenderFns } from "./PhotoInput.vue?vue&type=template&id=30a09a6c&scoped=true&"
import script from "./PhotoInput.vue?vue&type=script&lang=js&"
export * from "./PhotoInput.vue?vue&type=script&lang=js&"
import style0 from "./PhotoInput.vue?vue&type=style&index=0&id=30a09a6c&prod&lang=scss&scoped=true&"
import style1 from "./PhotoInput.vue?vue&type=style&index=1&id=30a09a6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a09a6c",
  null
  
)

export default component.exports